 
import toast, { Toaster } from 'react-hot-toast';
import ConnectButton from './components/ConnectButton';
import { Link } from 'react-router-dom';
import "../../App.css";

import { Hardcap, MaximumBuy, MinimumBuy, TokenRatePerEth, TotalSolded } from "../../hooks/useReadPresale";
import { useState } from 'react';
import { useAccount, useBalance } from 'wagmi';
import { BuyToken } from '../../hooks/useWritePresale';
import Contracts from '../../config/contract.json';
import CountdownCard from './components/CountdownCard';


function Home() {

    const { address,isConnected } = useAccount();
    

   const totalSoldedETH = (TotalSolded() / 1e18) - 200;
   //const hardcap = Hardcap() / 1e18;
   const hardcap = 130;
   const minBuy = MinimumBuy() / 1e18;
   const maxBuy = MaximumBuy() / 1e18;

    const TPerETH = TokenRatePerEth();

    const c = totalSoldedETH / hardcap;
   const progressbarvalue = Math.ceil(c * 100);


   const [token0,setToken0] = useState(); 
   const [token1,setToken1] = useState();

   const calculateToken = (e) =>{
    setToken0(e.target.value)
    const tokenamount = TPerETH * e.target.value;
    setToken1(tokenamount); 
}

const { data, isLoading, isError } = useBalance({
    address: address,
  });

const balance = data ? data.formatted : 0;

    const clickButton = () =>{
            if(token0 > 0 && balance > token0){
 
                BuyToken(token0,Contracts.presale).then((e)=>{
            
                    if(e.status == "success"){

                        toast.success("Buy Success");
                    
                    }else if(e.status == "error"){
                         
                        if(e.message.details){
                            toast.error(e.message.details);
                        }else{
                            toast.error(e.message.cause.data.args[0]);
                        }                          
                    }
                });

            }else{
                toast.error("Balance Error");
            }
        
    }


    const addTokenToMetamask = async () => {

        try{

            const wasAdded = await window.ethereum.request({
                method: 'wallet_watchAsset',
                params: {
                  type: 'ERC20',  
                  options: {
                    address: "0xdFCc2ddAe7fA54A3851CCF8d17E563f1A0fC7aE7",  
                    symbol: "AI",  
                    decimals: "18", 
                    image: "https://aigrain.store/assets/images/logo/logo.png", 
                  },
                },
              });
      
              if (wasAdded) {
                toast.success("Added Token");
                console.log('Added Token!');
              } 

        }catch(e){

            toast.error(e.message);

        }
    };

    return (
        <>
        <Toaster
          position="top-center"
          reverseOrder={false}
          />
             {/* ==========Header Section Starts Here========== */}
              <header className="header-section">
                  <div className="container">
                  <div className="header-holder">
                      <div className="header-primary d-flex flex-wrap justify-content-between align-items-center">
                      <div className="brand-logo d-none d-lg-inline-block">
                          <div className="logo">
                             <Link to="/"><img width={50} src="/assets/images/logo/logo.png" alt="logo" /></Link>
                          </div>
                      </div>
                      <div className="header-wrapper justify-content-lg-end">
                          <div className="mobile-logo d-lg-none">
                          <Link to="/"><img width={50} src="/assets/images/logo/logo.png" alt="logo" /></Link>
                          </div>
                          <div className="menu-area">
                                          
                          &nbsp;&nbsp;
                          <ConnectButton/>
                          {/* toggle icons */}
                           
                          </div>
                      </div>
                      </div>
                  </div>
                  </div>
              </header>
          {/* ==========Header Section Ends Here========== */}

          <section className="banner" id="home" style={{backgroundImage: 'url(./assets/images/banner/bg4.jpg)'}}>
        <div className="container">
          <div className="banner__wrapper">
            <div className="row g-5 align-items-center">
              <div className="col-lg-6">
                <div className="banner__content aos-init aos-animate" data-aos="fade-right" data-aos-duration={1000}>
                  <h1 className="text-uppercase">AIGRAIN (AI) <br />PRESALE LIVE</h1>
                 
                  <p>Aigrain is actively used and constantly developing in many areas that make our lives easier in the field of artificial intelligence. However, issues such as ethics, privacy and its effects on the workforce continue to be discussed.</p>
                  <a href="https://etherscan.io/search?q=0xdFCc2ddAe7fA54A3851CCF8d17E563f1A0fC7aE7" target='_blank' className="default-btn"><span>Contract Address</span></a>
                </div>
              </div>
              <div className="col-lg-6">
               
              <div className="login-section ">
        <div className=" container">
          <div className="account-wrapper">
            <div className="account-title">
              <h2>Aigrain Presale </h2>

              <div className='alert alert-warning  align-items-center px-4 py-3 rounded-pill border border-warning bg-warning bg-opacity-10'>
                
                <div className="fw-bold text-white">
    Final Presale Active - Listing: September 29
    </div>
              </div>

              <CountdownCard/>

              <p class="section-header__subtitle"> (1 ETH = {TPerETH} AI) </p>

              <br/>
              <div style={{fontSize: "18px",overflowWrap: "break-word",wordBreak: "break-all",textAlign: "center",}}><b>Presale Contract Address</b> <br/> <h6>{Contracts.presale}</h6></div>
            
            </div>
            <div className="account-form">

              <div className="form-group">
            <div className="input-container">
                <input type="text" className="form-control" onChange={(e)=>{calculateToken(e)}} value={token0} />
                <img src="/assets/images/logo/eth.png" alt="ETH" className="coin-logo" />
            </div>
            </div>
            
            <div className="form-group">
            <div className="input-container">
            <input type="text" className="form-control" readOnly onChange={(e)=>{setToken1(e.target.value)}} value={token1} />
                <img src="/assets/images/logo/logo.png" alt="AI" className="coin-logo" />
            </div>
            </div>

              <div className="project__item-amount">

              <div class="progress-info">
                <span class="amount"><h6> Min Buy: <span>{minBuy} ETH</span></h6></span>
                <span class="amount"><h6> Max Buy: <span>{maxBuy} ETH</span></h6></span>               
              </div>
                    <div className="progress">
                    <div className="progress-bar" role="progressbar" style={{width: progressbarvalue+'%', height:"100px"}} aria-valuenow={55} aria-valuemin={0} aria-valuemax={100} />
                    </div>
                  
                <div class="progress-info mt-3">
                <span class="amount"><h6> Solded: <span className='color--theme-color'> {totalSoldedETH.toFixed(4)} ETH</span></h6></span>
                <span class="amount"><h6> Hardcap: <span>{hardcap} ETH</span></h6></span>               
              </div>
                </div>

                <div
  style={{
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "16px",
    padding: "16px 20px",
    borderRadius: "14px",
    background:
      "linear-gradient(135deg, rgba(127, 29, 29, 0.35), rgba(69, 10, 10, 0.2))",
    border: "1px solid rgba(239, 68, 68, 0.25)",
    boxShadow: "0 8px 30px rgba(220, 38, 38, 0.12)",
    overflow: "hidden",
  }}
>
  {/* Red glow */}
  <div
    style={{
      position: "absolute",
      top: "-50px",
      right: "-30px",
      width: "120px",
      height: "120px",
      borderRadius: "50%",
      background: "rgba(239, 68, 68, 0.12)",
      filter: "blur(35px)",
      pointerEvents: "none",
    }}
  />

  <div
    style={{
      position: "relative",
      zIndex: 1,
      color: "rgba(255,255,255,0.65)",
      fontSize: "15px",
      fontWeight: "600",
      textDecoration: "line-through",
      textDecorationColor: "rgba(248,113,113,0.8)",
      textDecorationThickness: "2px",
    }}
  >
    Round 1 Hardcap: 200 ETH
  </div>

  <span
    style={{
      position: "relative",
      zIndex: 1,
      flexShrink: 0,
      display: "inline-flex",
      alignItems: "center",
      gap: "7px",
      padding: "6px 11px",
      borderRadius: "999px",
      background: "rgba(239, 68, 68, 0.12)",
      border: "1px solid rgba(239, 68, 68, 0.3)",
      color: "#f87171",
      fontSize: "11px",
      fontWeight: "800",
      letterSpacing: "0.8px",
      textTransform: "uppercase",
    }}
  >
    <span
      style={{
        width: "6px",
        height: "6px",
        borderRadius: "50%",
        background: "#ef4444",
        boxShadow: "0 0 8px rgba(239,68,68,0.8)",
      }}
    />

    Completed
  </span>
</div>
                  <h6 className='mt-3'><span>Round 2 Hardcap: <b>130 ETH</b></span></h6>

                <div class="final-presale-note">Listing: <b>$0.95</b> | Rate: <b>1 ETH = 270,000 AI</b></div>

              <div className="form-group">
                <button className="default-btn" onClick={ ()=>{
                    if(isConnected){
                        clickButton()
                    }else{
                        toast.error("First Connect Wallet");
                    }
                }}><span>Buy Token</span></button>
                <button className="default-btn" onClick={addTokenToMetamask}><span>Add Metamask</span></button>
              </div>
            </div>
          </div>
        </div>
      </div>  
              </div>
            </div>
          </div>
        </div>
      </section>


      <div className='container mt-5'  >
      <div className="pro-details__block mb-4">
        <div className="pro-details__block-inner">
          <div className="row g-5 align-items-center">

            <div className="col-lg-12">

            <div class="section-header section-header--middle"><div class="section-header__content"><div class="section-header__titlebar"><h2 class="section__header__title">IMPORTANT</h2></div></div></div>

            <div className="pro-details__item-wrap">
  <div
    className="pro-details__item"
    style={{
      position: "relative",
      overflow: "hidden",
      padding: "35px",
      borderRadius: "20px",
      background: "linear-gradient(145deg, #111827 0%, #0b1220 100%)",
      border: "1px solid rgba(255,255,255,0.08)",
      boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
      width: "100%",
      maxWidth: "100%",
      boxSizing: "border-box",
    }}
  >
    {/* Decorative glow */}
    <div
      style={{
        position: "absolute",
        width: "220px",
        height: "220px",
        top: "-120px",
        right: "-80px",
        borderRadius: "50%",
        background: "rgba(99,102,241,0.15)",
        filter: "blur(60px)",
        pointerEvents: "none",
      }}
    />

    <div
      style={{
        position: "relative",
        zIndex: 1,
        display: "flex",
        alignItems: "flex-start",
        gap: "25px",
        width: "100%",
        maxWidth: "100%",
        boxSizing: "border-box",
      }}
      className="aigrain-purchase-content"
    >
      {/* Logo */}
      <div
        className="pro-details__item-thumb"
        style={{
          flex: "0 0 72px",
          width: "72px",
          minWidth: "72px",
          height: "72px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "18px",
          background: "rgba(255,255,255,0.06)",
          border: "1px solid rgba(255,255,255,0.1)",
          boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
        }}
      >
        <img
          src="/assets/images/logo/logo.png"
          alt="logo"
          style={{
            maxWidth: "48px",
            maxHeight: "48px",
            objectFit: "contain",
          }}
        />
      </div>

      {/* Content */}
      <div
        className="pro-details__item-content"
        style={{
          flex: "1 1 auto",
          minWidth: 0,
          width: "100%",
          maxWidth: "100%",
          overflow: "hidden",
        }}
      >
        <h4
          style={{
            margin: "0 0 22px",
            fontSize: "26px",
            lineHeight: "1.3",
            fontWeight: "700",
            color: "#ffffff",
            letterSpacing: "-0.5px",
            overflowWrap: "break-word",
            wordBreak: "break-word",
          }}
        >
          AIGRAIN New Purchase Method
        </h4>

        <div
          style={{
            width: "50px",
            height: "3px",
            marginBottom: "24px",
            borderRadius: "10px",
            background: "linear-gradient(90deg, #6366f1, #8b5cf6)",
          }}
        />

        <p
          style={{
            marginBottom: "22px",
            color: "rgba(255,255,255,0.72)",
            fontSize: "15px",
            lineHeight: "1.9",
            overflowWrap: "break-word",
            wordBreak: "break-word",
          }}
        >
          Send ETH from your exchange to the AIGRAIN pre-sale address. 
          After completing your ETH transfer, create a MetaMask wallet or open your existing MetaMask wallet. 
          Copy your Ethereum ETH deposit address from MetaMask. 
          Send your MetaMask ETH address to the AIGRAIN team via Telegram. 
          Your ETH transaction will be verified via the blockchain to confirm your purchase. 
          AIGRAIN tokens from verified purchases will be distributed to the MetaMask addresses you provided on September 28th.
        </p>

        {/* Important Box */}
        <div
          style={{
            marginBottom: "25px",
            padding: "18px 20px",
            borderRadius: "14px",
            background: "rgba(245,158,11,0.07)",
            border: "1px solid rgba(245,158,11,0.18)",
            width: "100%",
            boxSizing: "border-box",
          }}
        >
          <p
            style={{
              margin: 0,
              color: "rgba(255,255,255,0.8)",
              fontSize: "14px",
              lineHeight: "1.8",
              overflowWrap: "break-word",
              wordBreak: "break-word",
            }}
          >
            Important: When sending ETH, only use the specified official AIGRAIN pre-sale address and make sure you select the correct Ethereum network.
          </p>
        </div>

        {/* Address */}
        <div
          style={{
            padding: "18px 20px",
            borderRadius: "14px",
            background: "rgba(255,255,255,0.04)",
            border: "1px solid rgba(255,255,255,0.07)",
            width: "100%",
            boxSizing: "border-box",
            overflow: "hidden",
          }}
        >
          <p
            style={{
              margin: 0,
              color: "#ffffff",
              fontSize: "13px",
              fontWeight: "700",
              letterSpacing: "1.5px",
              lineHeight: "1.7",
              overflowWrap: "anywhere",
              wordBreak: "break-word",
            }}
          >
            ADDRESS : 0x63B0913D543eCd684d9a5b2f267ba50B9ddF8074
          </p>
        </div>
      </div>
    </div>
  </div>

  <div className="btn-group mt-4 d-flex flex-wrap gap-20"></div>

  {/* Mobile Responsive */}
  <style>
    {`
      @media (max-width: 767px) {
        .aigrain-purchase-content {
          flex-direction: column !important;
          gap: 18px !important;
        }

        .aigrain-purchase-content .pro-details__item-thumb {
          width: 60px !important;
          min-width: 60px !important;
          height: 60px !important;
          flex: 0 0 60px !important;
        }

        .aigrain-purchase-content .pro-details__item-content h4 {
          font-size: 21px !important;
          line-height: 1.35 !important;
          margin-bottom: 18px !important;
        }

        .aigrain-purchase-content .pro-details__item-content p {
          font-size: 14px !important;
          line-height: 1.75 !important;
        }
      }

      @media (max-width: 480px) {
        .pro-details__item {
          padding: 22px !important;
          border-radius: 16px !important;
        }

        .aigrain-purchase-content {
          gap: 16px !important;
        }

        .aigrain-purchase-content .pro-details__item-content h4 {
          font-size: 19px !important;
        }
      }
    `}
  </style>
</div>


            </div>


            <div className="col-lg-12">

            <div class="section-header section-header--middle"><div class="section-header__content"><div class="section-header__titlebar"><h2 class="section__header__title">About</h2></div></div></div>

              <div className="pro-details__item-wrap">
                <div className="pro-details__item">
                  <div className="pro-details__item-thumb">
                  <img   src="/assets/images/logo/logo.png" alt="logo" />
                  </div>

                  
                  <div className="pro-details__item-content">
                    <h4>Aigrain <span>(AI)</span></h4>
                    <p>Aigrain's main goal is to develop human-like thinking, learning, problem-solving and decision-making abilities in machines. Artificial intelligence is considered a sub-branch of computer science and can be supported by different technologies.</p>
                    <p>Robotics <br/>
                    Artificial intelligence systems that perform tasks in the physical world. For example, they have knowledge, such as humanoid robots or automated manufacturing machines.</p>
                   <p>Aigrain is actively used and constantly developing in many areas that make our lives easier in the field of artificial intelligence. However, issues such as ethics, privacy and its effects on the workforce continue to be discussed.</p>
                  <p>Aigrain has trained 100,000 AI companies since 2023 and has agreements with many companies</p>
                  </div>
                </div>
                <div className="btn-group mt-4 d-flex flex-wrap gap-20">
                  
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>  
      </div> 

      <section className="roadmap  padding-bottom" id="roadmap">
        <div className="container">
          <div className="section-header section-header--middle">
            <div className="section-header__content">
              <div className="section-header__titlebar">
                <h2 className="section__header__title">Roadmap</h2>
              </div>
            </div>
          </div>
          <div className="roadmap__wrapper2">
            <div className="row gy-4 gy-md-0 gx-5">
              <div className="col-md-6 offset-md-6">
                <div className="roadmap__item2 ms-md-4 aos-init aos-animate" data-aos="fade-left" data-aos-duration={800}>
                  <div className="roadmap__item2-inner">
                    <div className="roadmap__item2-content">
                      <div className="roadmap__item2-header">
                        <h4>Presale Period</h4>
                        <p>01</p>
                      </div>
                      <p>The AIGrain presale period marks the initial phase of our journey, offering exclusive access to early investors. During this limited timeframe, participants can acquire AIGrain Coins at special rates, paving the way for future growth. Seize this opportunity before the presale ends!</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="roadmap__item2 ms-auto me-md-4 aos-init aos-animate" data-aos="fade-right" data-aos-duration={800}>
                  <div className="roadmap__item2-inner">
                    <div className="roadmap__item2-content">
                      <div className="roadmap__item2-header">
                        <h4>Cex Listing</h4>
                        <p>02</p>
                      </div>
                      <p>AIGrain will be listed on the exchange at an initial price of $0.95! This period marks a significant milestone as AIGrain Coin becomes available for global trading, increasing liquidity and accessibility.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 offset-md-6">
                <div className="roadmap__item2 ms-md-4 aos-init" data-aos="fade-left" data-aos-duration={800}>
                  <div className="roadmap__item2-inner">
                    <div className="roadmap__item2-content">
                      <div className="roadmap__item2-header">
                        <h4>2025 Target</h4>
                        <p>03</p>
                      </div>
                      <p>AIGrain Coin is aiming to reach a value of $13 by 2025! With our innovative projects and strategic roadmap, we are committed to delivering long-term growth and value for our investors. Join us as we build the future today!</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      <footer className="footer" style={{backgroundImage: 'url(./assets/images/footer/bg.png)'}}>
        <div className="footer__wrapper padding-top padding-bottom">
          <div className="container">
            <div className="footer__content text-center">
              <a className="mb-4 d-inline-block" href="index.html"><img src="./assets/images/logo/logo.png" width={50} alt="Logo" /></a>
              <ul className="social justify-content-center">
                 
                <li className="social__item">
                  <a href="https://t.me/aigrain_ai" target='_blank' className="social__link">
                  <i class="fab fa-telegram"></i>
                    </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="footer__copyright">
          <div className="container">
            <div className="text-center py-4">
              <p className=" mb-0">AIGrain © 2026 | All Rights Reserved </p>
            </div>
          </div>
        </div>
      </footer>

 
        </>
    );
  }
  
  export default Home;